export var RotationDirectionType;
(function (RotationDirectionType) {
    RotationDirectionType[RotationDirectionType["ClockWise"] = 0] = "ClockWise";
    RotationDirectionType[RotationDirectionType["ReverseClockWise"] = 1] = "ReverseClockWise";
})(RotationDirectionType || (RotationDirectionType = {}));
